class DOM {
    /**
     * Visit an ArrayLike object the same way as NodeList
     */
    forEach(elements, callback) {
        for (let i = 0; i < elements.length; i++) {
            if (elements[i]) {
                callback(elements[i], i);
            }
        }
    }
    /**
     * Check if node has certain class
     * @deprecated Use Element.classList.contains instead
     */
    hasClass(elem, className) {
        if (!elem) {
            return false;
        }
        return elem.classList ? elem.classList.contains(className) : false;
    }
    /**
     * Add a CSS class to nodes
     */
    addClass(elems, className) {
        if (elems) {
            if (!('length' in elems)) {
                elems = [elems];
            }
            this.forEach(elems, elem => {
                if (elem.classList) {
                    elem.classList.add(className);
                }
            });
        }
        return this;
    }
    /**
     * Remove a CSS class from nodes
     */
    removeClass(elems, className) {
        if (elems) {
            if (!('length' in elems)) {
                elems = [elems];
            }
            this.forEach(elems, elem => {
                if (elem.classList) {
                    elem.classList.remove(className);
                }
            });
        }
        return this;
    }
    /**
     * Remove all child-nodes
     */
    removeAllChildren(node) {
        while (node.firstChild) {
            node.removeChild(node.firstChild);
        }
    }
    /**
     * Create element from HTML string
     */
    fromHtml(html) {
        return document.createRange().createContextualFragment(html);
    }
}
const dom = new DOM();
export default dom;
